import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="ve-container ve-section text-center">
      <div className="ve-eyebrow">404</div>
      <h1 className="ve-h1 mt-3">Page not found.</h1>
      <p className="ve-lead mt-5">That page has either been moved, retired, or never existed.</p>
      <Link to="/" className="ve-btn-primary mt-8 inline-flex">Take me home</Link>
    </main>
  );
}
